/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FetchData, imgHeaderDataNew } from "app/shared/generalMethods";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { imgHeaderData, youthCenterImg } from "app/shared/generalMethods";
import { DatePipe } from "@angular/common";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthorizeNetService } from "app/services/authorizeNet.service";
import { FormBuilder, Validators } from "@angular/forms";
import { ParentPortalService } from "app/services/parentPortal.service";
import { AuthorizedPaymentComponent } from "./authorized-payment/authorized-payment.component";

@Component({
  selector: "app-payment-receipt",
  templateUrl: "./payment-receipt.component.html",
  styleUrls: ["./payment-receipt.component.scss"],
  providers: [DatePipe, AuthorizedPaymentComponent],
})
export class PaymentReceiptComponent implements OnInit {
  userRecord: any;
  recordId = null;
  kidId = null;
  invoicesToDisplay: any[] = [];
  parentName: string = "";
  parentEmail: string = "";
  childName: string = "";
  loading: boolean = false;
  showInvoiceModal: boolean = false;
  selectedInvoice: any = null;
  selectedInvoiceId: string | null = null;
  paymentProcessing = false;
  card: any;
  payments: any;
  paymentStatusMessage: string = "";
  paymentNowLoading = false;
  paymentMethod: "stripe" | "authorizeNet" = "stripe";
  @ViewChild("cardContainer") cardContainer?: ElementRef;
  @ViewChild("authorizeNetForm") authorizeNetForm?: ElementRef;
  paymentForm: any;
  paymentToken: string | null = null;
  pageLoader: any;
  pageLoaderText: any;
  apiResult: any;
  processingPayment: boolean = false;
  processingMessage: string = "We are processing your payment. Please wait...";

  constructor(
    private router: ActivatedRoute,
    private _fetchData: FetchData,
    private _router: Router,
    private datePipe: DatePipe,
    private authorizeNetService: AuthorizeNetService,
    private parentPortalService: ParentPortalService,
    private _snackBar: MatSnackBar,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.userRecord = this._fetchData.data;
    this.loadParentData();

    this.router.queryParams.subscribe((params) => {
      this.recordId = params["id"];
      this.kidId = params["kidId"];

      const status = params["status"];
      if (status === "success") {
        this.paymentStatusMessage = "Payment successful.";
        this.showSnackbar(this.paymentStatusMessage, "success");
      } else if (status === "cancelled") {
        this.paymentStatusMessage = "ayment was cancelled.";
        this.showSnackbar(this.paymentStatusMessage, "error");
      } else if (status === "failed") {
        this.paymentStatusMessage = "Payment failed. Please try again.";
        this.showSnackbar(this.paymentStatusMessage, "error");
      }

      this.processInvoices();
      this.loading = false;
    });
  }

  private showSnackbar(message: string, type: "success" | "error"): void {
    this._snackBar.open(message, "Close", {
      duration: 4000,
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  togglePaymentForm(invoice: any): void {
    this.selectedInvoiceId =
      this.selectedInvoiceId === invoice.Id ? null : invoice.Id;
  }

  // async handlePaymentNow(invoice: any): Promise<void> {
  //     if (this.paymentNowLoading) {
  //         return;
  //     }

  //     this.paymentNowLoading = true;

  //     try {
  //         const paymentData = {
  //             cardData: {
  //                 cardNumber: this.paymentForm.value.cardNumber.replace(/\s+/g, ""),
  //                 expirationDate: `${this.paymentForm.value.expMonth}${this.paymentForm.value.expYear.slice(-2)}`,
  //                 cardCode: this.paymentForm.value.cvv,
  //             },
  //             amount: invoice.Program_Fee__c,
  //             invoiceId: invoice.Id,
  //             parentIdOrUid: this._fetchData.parentId,
  //             email: this.paymentForm.value.email?.trim() || null,
  //         };

  //         const result = await this.authorizeNetService.processPayment(paymentData).toPromise();

  //         if (!result?.success) {
  //             throw new Error(result?.message || 'Payment failed');
  //         }
  //     } catch (error: any) {
  //         this.showSnackbar(
  //             error.message || "Payment processing failed",
  //             "error"
  //         );
  //         throw error;
  //     } finally {
  //         this.paymentNowLoading = false;
  //     }
  // }

  async confirmPayment(invoice: any): Promise<void> {
    if (this.paymentForm.invalid || this.paymentProcessing) {
      return;
    }

    const paidInvoices = JSON.parse(
      localStorage.getItem("paidInvoices") || "{}"
    );
    if (paidInvoices[invoice.Id]) {
      this.showSnackbar(
        "⚠️ This invoice has already been paid. It will be updated soon.",
        "error"
      );
      return;
    }

    this.paymentProcessing = true;
    this.processingPayment = true;

    try {
      const paymentData = {
        cardData: {
          cardNumber: this.paymentForm.value.cardNumber.replace(/\s+/g, ""),
          expirationDate: `${
            this.paymentForm.value.expMonth
          }${this.paymentForm.value.expYear.slice(-2)}`,
          cardCode: this.paymentForm.value.cvv,
        },
        amount: invoice.Program_Fee__c,
        invoiceId: invoice.Id,
        parentIdOrUid: this._fetchData.parentId,
        email: this.paymentForm.value.email?.trim() || null,
      };

      const result = await this.authorizeNetService
        .processPayment(paymentData)
        .toPromise();

      if (result?.success) {
        // Full success
        paidInvoices[invoice.Id] = {
          transactionId: result.transactionId,
          timestamp: new Date().toISOString(),
        };
        localStorage.setItem("paidInvoices", JSON.stringify(paidInvoices));

        if (result.recordUpdateFailed) {
          this.showSnackbar(
            "✅ Payment successful but record was not updated. Admin has been notified.",
            "error"
          );
          return;
        }

        this.handlePostPaymentUpdate(invoice);
      } else if (result?.paymentReceived) {
        // Partial success
        paidInvoices[invoice.Id] = {
          transactionId: result.transactionId || null,
          timestamp: new Date().toISOString(),
        };
        localStorage.setItem("paidInvoices", JSON.stringify(paidInvoices));

        this.showSnackbar(
          "✅ Payment successful, but record update failed. Admin has been notified.",
          "error"
        );
      } else {
        // Full failure
        throw new Error(result?.error || result?.message || "Payment failed");
      }

      // Reset form
      this.selectedInvoiceId = null;
      this.paymentForm.reset();
    } catch (error: any) {
      console.error("🔴 Payment processing error:", error);
      const errMsg = error?.error?.message || error.message || "Payment failed";

      this.showSnackbar(
        errMsg === "This invoice has already been paid."
          ? "⚠️ This invoice has already been paid."
          : errMsg,
        "error"
      );
    } finally {
      this.paymentProcessing = false;
      this.processingPayment = false;
    }
  }
  private handlePostPaymentUpdate(invoice: any): void {
    const parentId = this._fetchData.parentId;

    this.parentPortalService.getParentByUID(parentId).subscribe({
      next: (parentData) => {
        const parentRecord = this._fetchData.data.lstParents?.[0];

        if (!parentRecord) {
          console.warn("⚠️ No parent record found — skipping update");
          this.showSnackbar(
            "⚠️ Payment successful, but no parent record found to update.",
            "error"
          );
          return;
        }

        const mappedParent = this.mapParentRecordToFormValues(parentRecord);

        this.parentPortalService
          .updateParent(mappedParent, parentId)
          .subscribe({
            next: (response) => {
              this.apiResult = this._fetchData.parseIntoJSON(response.msg);

              if (this.apiResult.data === null) {
                // Optional maintenance logic
              } else if (this.apiResult.success === true) {
                this._fetchData.setLocalStorage(response.msg);
                this.showSnackbar(
                  "✅ Payment has been received successfully!",
                  "success"
                );
                setTimeout(() => window.location.reload(), 1500);
              } else {
                this.showSnackbar(this.apiResult.error.message, "error");
              }
            },
            error: (err) => {
              console.error("🔴 Failed to update parent:", err);
              this.showSnackbar(
                "⚠️ Payment successful, but parent update failed.",
                "error"
              );
            },
            complete: () => {
              this.processingPayment = false;
            },
          });
      },
      error: (err) => {
        console.error("🔴 Failed to fetch parent by UID:", err);
        this.showSnackbar(
          "⚠️ Payment successful, but failed to fetch parent info.",
          "error"
        );
        this.processingPayment = false;
      },
    });
  }

  private mapParentRecordToFormValues(record: any): any {
    return {
      pgiFullName: record.Name || "",
      pgiEmail: record.Parent_Email__c || "",
      pgiCity: record.Town_City__c || "",
      pgiPostalCode: record.Postal_Code__c || "",
      pgiPhysicalAddress: record.Physical_Address__c || "",
      pgiHomePhone: record.Home_Phone__c || "",
      pgiWorkPhone: record.Work_Phone__c || "",
      pgiIsRural: record.Is_Rural__c,
      pgiCellPhone: record.Cell_Phone__c || "",
      pgiParentImage: record.Parent_Image__c || "",
      nameSp: record.Second_Parent_Name__c || "",
      emailSp: record.Second_Parent_Email__c || "",
      postalCodeSp: record.Second_Postal_Code__c || "",
      citySp: record.Second_Parent_City__c || "",
      addressSp: record.Second_Physical_Address__c || "",
      homePhoneSp: record.Second_Home_Phone__c || "",
      workPhoneSp: record.Second_Work_Phone__c || "",
      cellPhoneSp: record.Second_Cell_Phone__c || "",
    };
  }

  private loadParentData(): void {
    const lstParents = this.userRecord?.lstParents || [];
    if (lstParents.length > 0) {
      this.parentName = lstParents[0].Name || "N/A";
      this.parentEmail = lstParents[0].Parent_Email__c || "N/A";
    }

    const lstKids = this.userRecord?.lstKids || [];
    if (lstKids.length > 1) {
      this.childName = lstKids[0].Name || "N/A";
    }
  }

  private processInvoices(): void {
    if (
      this.recordId &&
      this.userRecord?.lstInvoices?.length > 0 &&
      this.userRecord?.lstRegistrationSchedules?.length > 0 &&
      this.userRecord?.lstPrograms?.length > 0
    ) {
      const child = this.userRecord.lstKids.find(
        (k) => k.Id === this.kidId
      ) || { Name: "N/A" };

      this.invoicesToDisplay = this.userRecord.lstInvoices
        .filter((inv) => {
          // Match the program registration
          if (inv.Program_Registration__c !== this.recordId) {
            return false;
          }

          // Find the related schedule
          const schedule = this.userRecord.lstRegistrationSchedules.find(
            (sched) => sched.Id === inv.Registration_Schedule__c
          );

          // Exclude if schedule status is CANCELLED
          if (schedule?.Is_Cancelled__c === true) {
            return false;
          }

          return true;
        })
        .map((inv) => {
          const schedule = this.userRecord.lstRegistrationSchedules.find(
            (sched) => sched.Id === inv.Registration_Schedule__c
          );

          const registration = this.userRecord.lstProgramRegistrations.find(
            (reg) => reg.Id === inv.Program_Registration__c
          );

          const program = registration
            ? this.userRecord.lstPrograms.find(
                (p) => p.Id === registration.Program__c
              )
            : null;

          const fullScheduleName =
            schedule?.Class_Schedule__r?.Name ||
            schedule?.Class_Schedule__c ||
            "N/A";

          const cleanedProgramName = this.cleanScheduleName(
            program?.Name || "N/A"
          );

          return {
            ...inv,
            classScheduleName: fullScheduleName,
            programName: cleanedProgramName,
            paymentDate: inv.Invoice_Paid_Date__c
              ? this.datePipe.transform(inv.Invoice_Paid_Date__c, "mediumDate")
              : "Pending",
            isFullPayment: inv.Invoice_Type__c === "Full Payment",
            paymentType: inv.Invoice_Type__c || "Class Payment",
            childName: child.Name,
            billingType:
              registration?.Is_Payment_Recurring__c === true
                ? "Auto Recurring Billing"
                : registration?.Is_Payment_Recurring__c === false
                ? "Manual Billing"
                : "Unknown",
          };
        });
    }
  }

  openInvoiceModal(invoice: any): void {
    this.selectedInvoice = invoice;
    this.showInvoiceModal = true;
  }

  closeInvoiceModal(): void {
    this.showInvoiceModal = false;
    this.selectedInvoice = null;
  }

  formatNotesForDisplay(notes: string): SafeHtml {
    if (!notes) {
      return "";
    }

    const sections = notes.split("Class Schedules");
    let formattedHtml = "";

    if (sections[0]) {
      const regSchedules = sections[0]
        .replace("Registration Schedule -", "")
        .trim();
      if (regSchedules) {
        const regItems = regSchedules.split(",").filter((item) => item.trim());
        if (regItems.length > 0) {
          formattedHtml +=
            '<div class="notes-section"><strong>Registration Schedules:</strong><ol>';
          regItems.forEach((item) => {
            formattedHtml += `<li>${item.trim()}</li>`;
          });
          formattedHtml += "</ol></div>";
        }
      }
    }

    if (sections[1]) {
      const classSchedules = sections[1].replace("-", "").trim();
      if (classSchedules) {
        const classItems = classSchedules
          .split(",")
          .filter((item) => item.trim());
        if (classItems.length > 0) {
          formattedHtml +=
            '<div class="notes-section"><strong>Class Schedules:</strong><ol>';
          classItems.forEach((item) => {
            formattedHtml += `<li>${item.trim()}</li>`;
          });
          formattedHtml += "</ol></div>";
        }
      }
    }

    return this.sanitizer.bypassSecurityTrustHtml(
      formattedHtml || "No schedule information available"
    );
  }

  private cleanScheduleName(scheduleName: string): string {
    if (!scheduleName) {
      return scheduleName;
    }
    const lastDashIndex = scheduleName.lastIndexOf(" - ");
    return lastDashIndex > 0
      ? scheduleName.substring(0, lastDashIndex)
      : scheduleName;
  }

  goBack(): void {
    this._router.navigate(["/registered-programs"]);
  }

  generateReceiptPDF(invoice: any): void {
    const pdf = new jsPDF();
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const centerX = pdfWidth / 2;
    const margin = 20;

    const primaryColor: [number, number, number] = [68, 70, 84]; // dark gray
    const accentColor: [number, number, number] = [122, 193, 66]; // green

    // --- Header ---
    try {
      pdf.addImage(imgHeaderDataNew, "PNG", 16, 6, 62, 15); // TrailFusion logo
      pdf.setFontSize(16);
      pdf.setFont("helvetica", "bold");
      pdf.setTextColor(40);
    } catch (e) {
      console.warn("Header image failed:", e);
    }

    // --- Title ---
    pdf.setFontSize(14);
    pdf.setTextColor(...primaryColor);
    pdf.setFont("helvetica", "bold");
    pdf.text("PAYMENT RECEIPT", centerX, 30, { align: "center" });

    // Decorative line under title
    pdf.setDrawColor(...primaryColor);
    pdf.setLineWidth(0.5);
    pdf.line(margin, 35, pdfWidth - margin, 35);

    // --- Receipt Info ---
    pdf.setFontSize(10);
    let yPosition = 45;

    pdf.text(`Receipt #: ${invoice.Name}`, margin, yPosition);
    pdf.text(`Date: ${new Date().toLocaleDateString()}`, margin, yPosition + 5);
    pdf.text(
      `Status: ${invoice.Invoice_Paid__c ? "PAID" : "PENDING"}`,
      margin,
      yPosition + 10
    );

    pdf.text(`Parent: ${this.parentName}`, pdfWidth - margin, yPosition, {
      align: "right",
    });
    pdf.text(`Child: ${invoice.childName}`, pdfWidth - margin, yPosition + 5, {
      align: "right",
    });

    yPosition += 20;

    // --- Payment Details ---
    pdf.setFontSize(12);
    pdf.setTextColor(...primaryColor);
    pdf.setFont("helvetica", "bold");
    pdf.text("Payment Details", margin, yPosition);
    yPosition += 8;

    const paymentDetails = [
      ["Program Name:", this.cleanScheduleName(invoice.programName)],
      ["Payment Type:", invoice.Invoice_Title__c],
      ["Amount Paid:", this.formatCurrency(invoice.Program_Fee__c)],
      ["Payment Method:", invoice.Invoice_Paid__c ? "Card" : "Pending"],
    ];

    autoTable(pdf, {
      startY: yPosition,
      head: [["Description", "Value"]],
      body: paymentDetails,
      margin: { left: margin, right: margin },
      headStyles: {
        fillColor: accentColor,
        textColor: 255,
        fontStyle: "bold",
        fontSize: 10,
      },
      bodyStyles: {
        fontSize: 10,
        cellPadding: 4,
      },
      theme: "grid",
      styles: {
        lineWidth: 0.2,
        cellPadding: 3,
      },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: "auto" },
        1: { cellWidth: "wrap" },
      },
    });

    yPosition = (pdf as any).lastAutoTable.finalY + 12;

    // --- Notes / Schedules ---
    if (invoice.Notes__c) {
      pdf.setFontSize(12);
      pdf.setTextColor(...primaryColor);
      pdf.text("Schedules:", margin, yPosition);
      yPosition += 8;

      const formattedNotes = this.formatNotesForPDF(invoice.Notes__c);
      const notes = pdf.splitTextToSize(formattedNotes, pdfWidth - 2 * margin);

      pdf.setFillColor(245, 245, 245); // light gray background
      pdf.rect(
        margin,
        yPosition - 2,
        pdfWidth - 2 * margin,
        notes.length * 5 + 4,
        "F"
      );

      pdf.setTextColor(60);
      pdf.setFontSize(10);
      pdf.text(notes, margin + 2, yPosition + 2);
      yPosition += notes.length * 5 + 10;
    }

    // --- Footer ---
    this.setPdfFooterContent(pdf, centerX, pdfHeight, pdfWidth, margin);

    // Save
    pdf.save(`Payment_Receipt_${invoice.Name.replace(/\s+/g, "_")}.pdf`);
  }
  private setPdfFooterContent(
    pdfObj: jsPDF,
    centerX: number,
    pdfHeight: number,
    pdfWidth: number,
    margin: number
  ): void {
    pdfObj.setFontSize(8);
    pdfObj.setTextColor(100, 100, 100);
    pdfObj.setFont("helvetica", "normal");

    pdfObj.setDrawColor(200);
    pdfObj.line(margin, pdfHeight - 25, pdfWidth - margin, pdfHeight - 25);

    const orgInfo = [
      "Tel: (437)-225-2458 | 4045 Industrial Drive Unit A Windsor ON N9C 3R8 Canada | Email: info@trailfusion.net",
    ];

    pdfObj.text(orgInfo[0], centerX, pdfHeight - 15, { align: "center" });

    const pageNum = pdfObj.getNumberOfPages();
    for (let i = 1; i <= pageNum; i++) {
      pdfObj.setPage(i);
      pdfObj.text(
        `Page ${i} of ${pageNum}`,
        pdfWidth - margin,
        pdfHeight - 10,
        { align: "right" }
      );
    }
  }

  private formatNotesForPDF(notes: string): string {
    if (!notes) {
      return "No schedule information available";
    }

    // Split notes into registration and class schedules sections
    const sections = notes.split("Class Schedules");
    let formattedText = "";

    // Process registration schedules
    if (sections[0]) {
      const regSchedules = sections[0]
        .replace("Registration Schedule -", "")
        .trim();

      if (regSchedules) {
        const regItems = regSchedules
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item);

        if (regItems.length > 0) {
          formattedText +=
            "REGISTRATION SCHEDULES: " + regItems.join(", ") + "\n\n";
        }
      }
    }

    // Process class schedules
    if (sections[1]) {
      const classSchedules = sections[1].replace("-", "").trim();

      if (classSchedules) {
        const classItems = classSchedules
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item);

        if (classItems.length > 0) {
          formattedText += "CLASS SCHEDULES: " + classItems.join(", ");
        }
      }
    }

    return formattedText || "No schedule information available";
  }
  private formatCurrency(amount: number): string {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 2,
    }).format(amount);
  }
}
